/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import LCD from '@appblocks/codegeneration/Features/LCD';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;

    const lcdGraph = project.getFeature('lcd_graph');
    if (!lcdGraph) {
        return blocks;
    }
    const WIDTH = lcdGraph.getSettingValue('WIDTH');
    const lcdGraphId = lcdGraph.getID();
    const doneLinks = project.getNodeLinks(feature, 'done');
    const doneBlock = doneLinks.length > 0 ? `/****${doneLinks[0].getSourceId()}****/` : '';
    const links = project.getNodeLinks(feature, 'lcd_graph_add');
    for (let i = 0; i < links.length; i += 1) {
        const link = links[i];
        const value = project.getNodeParameter(link, 'point');
        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
const DATAPOINTS = simulator.context["${lcdGraphId}"].DATAPOINTS;
DATAPOINTS.push(${value});
if (DATAPOINTS.length > ${WIDTH} / 3 + 1) {
    DATAPOINTS.shift();
}
simulator.updateContext("${lcdGraphId}", {
    ...simulator.context["${lcdGraphId}"],
    DATAPOINTS,
});
${doneBlock}`,
        });
    }

    return blocks;
};
